import React from 'react';
import ReactDOM from 'react-dom';
import classnames from 'classnames';
import ArrowIcon from './ArrowIcon';
import * as uiHelper from '../util/ui';
require('./style.scss');

const SHOW_PULL = 0;
const SHOW_RELEASE = 1;

export default class PullToRefresh extends React.Component {
     static defaultProps = {
        isRefreshing: false
    }

    constructor(...args) {
        super(...args);
        this.state = {
            pull: SHOW_PULL
        };

        this._onScroll = event => window.requestAnimationFrame(() => this._handleScroll());
        this._onTouchEnd = event => this._handleTouchEnd(event);
        this._onTouchMove = event => this._handleTouchMove(event);
        this._onTouchStart = event => this._handleTouchStart(event);
    }

    componentDidMount() {
        const pullEl = ReactDOM.findDOMNode(this.refs.pullToRefresh);
        this._listParent = ReactDOM.findDOMNode(this.refs.listParent);
        this._pullHeight = pullEl.getBoundingClientRect().height;

        const scrollElement = this._getScrollParent();
        if(scrollElement) {
            scrollElement.addEventListener('scroll', this._onScroll);
        }

        this._resetPullInfo();

        const scrolltop = this._getScrollTop();
        if (scrolltop <= 0) {
            this._enablePTR();
        }

        this.registerEventForRecordMovePoint();
    }

    registerEventForRecordMovePoint() {
        if(this._listParent) {
            this._listParent.addEventListener('touchmove', e => {
                this.currentY = e.touches[0].clientY;
            });
            this._listParent.addEventListener('touchstart', e => {
                this.moveStartY = e.touches[0].clientY;
            });
        }
    }

    render() {
        const icon = (this.props.isRefreshing) ?
        <span className="table-icon-loading" /> :
        <ArrowIcon className={classnames('arrow-down', { 'arrow-up': this.state.pull === SHOW_RELEASE })} />;

        return (
            <div className="pull-to-refresh" ref='listParent'>
                <div className="ptr" ref='pullToRefresh'>
                {icon}
                </div>
                {this.props.children}
            </div>);
    }

    componentWillUnmount() {
        const scrollElement = this._getScrollParent();
        if(scrollElement) {
            scrollElement.removeEventListener('scroll', this._onScroll);
        }

    }

    componentWillReceiveProps(nextProps) {
        if (this.props.isRefreshing && !nextProps.isRefreshing) {
            this.setState({ pull: SHOW_PULL });
            const scrolltop = this._getScrollTop();
            if (scrolltop <= 0) {
                this._enablePTR();
            }
            this._resetPullInfo();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.isRefreshing && !this.props.isRefreshing && this.state.pull === SHOW_PULL) {
            this._cleanup();
        }

        const sid = setTimeout(() => {
            if(!this.props.isRefreshing && this._pullInfo.distance === this._pullInfo.lastPull && this._pullInfo.distance > 0 && this.state.pull == SHOW_RELEASE) {
                //this._setTransform(0, true);
                this._release(this._pullInfo.distance);
                clearTimeout(sid);
            }
        }, 500);
    }

    _getScrollParent() {
        this._scrollParent = this._scrollParent || uiHelper.getScrollParent(ReactDOM.findDOMNode(this));
        return this._scrollParent;
    }

    _getScrollTop() {
        const scrollParent = this._getScrollParent();
        return uiHelper.getScrollTop(scrollParent);
    }

    _enablePTR() {
        if (!this._inPTR) {
            this._inPTR = true;
            // Handling touch events in Safari, even when they are just thrown out, degrades
            // performance noticeably. It's imperative to add/remove them as needed.
            this._listParent.addEventListener('touchend', this._onTouchEnd);
            this._listParent.addEventListener('touchmove', this._onTouchMove);
            this._listParent.addEventListener('touchstart', this._onTouchStart);
            this._listParent.style.overflow = 'visible';
        }
    }

    _disablePTR() {
        // Cancels out of the PTR cycle
        this._pullInfo.moved = false;
        if (this._inPTR) {
            this._inPTR = false;
            this._listParent.removeEventListener('touchend', this._onTouchEnd);
            this._listParent.removeEventListener('touchmove', this._onTouchMove);
            this._listParent.removeEventListener('touchstart', this._onTouchStart);
            this._setTransform(0, true);
            this._cleanup();
        }
    }

    _updatePullState(currentDistance, nextDistance) {
        const { lastPull } = this._pullInfo;
        if (nextDistance > this._pullHeight) {
        // Release-able. If released, will fire callback.

            if (this.state.pull === SHOW_PULL) {
                this.setState({ pull: SHOW_RELEASE });
            }
            this._pullInfo.lastPull = nextDistance;
            return;
        }

        if (currentDistance > 0 && currentDistance < lastPull) {
            if (this.state.pull === SHOW_RELEASE) {
                // No longer release-able. If released, will reset to null-state.
                this.setState({ pull: SHOW_PULL });
            }
            return;
        }
    }

    _updatePullPosition(distance) {
        this._pullInfo.moved = true;
        this._setTransform(distance);
    }

    _release(translation) {
        if (translation > this._pullHeight) {
            this._pullInfo.ended = true;
            // Good to go. Fire refresh callback
            if (!this.props.isRefreshing) {
                this.props.onRefresh();
            }
            this._setTransform(this._pullHeight, true);
        }

        this.setState({ pull: SHOW_PULL });
    }

    _handleScroll() {
        if(this.moveStartY > 0 && (this.currentY - this.moveStartY < 0)) {
            this._disablePTR();
            return null;
        }

        const scrolltop = this._getScrollTop();
        if (scrolltop <= 0) {
            this._enablePTR();
        } else {
            this._disablePTR();
        }
    }

     _handleTouchStart(event) {
        if (!this._pullInfo.ended && !this.props.isRefreshing && !this.isCleanning) {
            this._pullInfo.ended = false;
            this._pullInfo.startY = event.touches[0].clientY;
        }
    }

    _handleTouchMove(event) {
        if (this._pullInfo.ended || this.props.isRefreshing || this.isCleanning) {
            event.preventDefault();
            event.stopPropagation();
            return;
        }

        const touch = event.touches[0];
        const currentY = touch.clientY;
        const distance = Math.round((currentY - this._pullInfo.startY) * 0.4);

        if (distance <= 0 && this._pullInfo.distance === 0) {
            return;
        }

        if (distance > 0) {
            // If we prevent and we're not at the top, scrolling and momentum will be killed
            event.preventDefault();
            event.stopPropagation();
        }

        window.requestAnimationFrame(() => {
            this._updatePullPosition(distance);
            this._updatePullState(this._pullInfo.distance, distance);
            this._pullInfo.distance = distance;
        });
    }

    _handleTouchEnd(event) {
        const { distance, ended, moved } = this._pullInfo;

        if (ended || this.props.isRefreshing || this.isCleanning) {
            return;
        }

        if (moved) {
            event.preventDefault();
            event.stopPropagation();

            if (distance > this._pullHeight) {
                this._release(distance);
            } else {
                this._setTransform(0, true);
            }
        } else {
            this._cleanup();
            this._resetPullInfo();
        }
    }

    _resetPullInfo() {
        this._pullInfo = {
            distance: 0,
            ended: false,
            lastPull: 0,
            moved: false,
            startY: null
        };
    }

    _cleanup() {
        this.isCleanning = true;
        this.refs.pullToRefresh.classList.remove('show-arrow-down');
        this._listParent.style.WebkitTransition = null; // 1
        this._listParent.style.transition = null;
        this._listParent.style.WebkitTransform = null; // 1
        this._listParent.style.transform = null;
        if (!this._inPTR) {
            this._listParent.style.overflow = null;
        }
        this.isCleanning = false;
    }

    _setTransform(distance, animate) {
        if(distance === 0) {
            this.isCleanning = true;
        }
        const transform = 'translate3d(0,' + distance + 'px,0)';
        const transition = animate ? 'transform 100ms' : null;
        this._listParent.style.WebKitTransition = transition; // 1
        this._listParent.style.transition = transition;
        this._listParent.style.WebkitTransform = transform; // 1
        this._listParent.style.transform = transform;

        if(this.refs.pullToRefresh) {
            if(distance >= 35) {
                this.refs.pullToRefresh.classList.add('show-arrow-down');
            }else {
                this.refs.pullToRefresh.classList.remove('show-arrow-down');
            }
        }

        if(distance === 0) {
            this.isCleanning = false;
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/PullToRefresh/index.js